<script setup lang="ts">
    import type { ClassValue } from 'vue';
    import BasicCheckbox from './BasicCheckbox.vue';

    const {
        id,
        label,
        labelPosition = 'right',
        variant = 'primary',
        labelClass = undefined
    } = defineProps<{
        label: string;
        labelPosition?: 'left' | 'right';
        variant?: 'primary' | 'secondary' | 'tertiary';
        id: string;
        labelClass?: ClassValue;
    }>();

    defineOptions({ inheritAttrs: false });

    const checked = defineModel<boolean>({ required: true });
</script>

<template>
    <div
        :class="{
            'checkbox-wrapper': true,
            'left-label': labelPosition === 'left'
        }"
    >
        <label
            :for="id"
            :title="label"
            :class="labelClass"
            >{{ label }}</label
        >

        <BasicCheckbox
            v-bind="$attrs"
            :id="id"
            :model-value="checked"
            :variant="variant"
            @update:model-value="checked = $event"
        />
    </div>
</template>

<style scoped lang="scss">
    .checkbox-wrapper {
        display: flex;
        align-items: center;
        justify-content: space-between;
        width: 100%;
        flex-wrap: nowrap;
        gap: var(--spacing);
        flex-direction: row-reverse;

        &.left-label {
            flex-direction: row;
        }

        label {
            cursor: pointer;
            width: 100%;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
        }
    }
</style>
